import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import Alert from 'components/Common/Alert/Alert';
import LoginMetadata from 'components/Identification/Login/LoginMetadata';
import { default as LoginContainer } from 'components/Identification/Login/Login';
import PaBanner from 'components/Identification/PaBanner/PaBanner';
import useCurrentCountry from 'hooks/useCurrentCountry';
import useGtmPageView from 'hooks/gtm/useGtmPageView';
import { GTM_PAGE_LOGIN } from 'settings/gtm/gtmPageView';

import styles from './page.module.scss';

export default function Login(): JSX.Element {
  const { t } = useTranslation(['loginPage']);
  const { isUk } = useCurrentCountry();
  const { state } = useLocation();

  useGtmPageView(GTM_PAGE_LOGIN, `Afibel - ${t('LOGIN_META_TITLE')}`);

  return (
    <div className={styles.container}>
      <LoginMetadata />
      <div>
        <h1 className={styles.title}>{t('LOGIN_TITLE_PAGE')}</h1>
      </div>
      {state?.redirectResetPassword && (
        <div className={styles.alert}>
          <Alert severity="success" label={t('LABEL_SUCCESS_RESET_PASSWORD')} />
        </div>
      )}
      {state?.mandatoryLogInNewsletter && (
        <div className={styles.alert}>
          <Alert severity="warning" label={t('LABEL_WARNING_NEWSLETTER')} />
        </div>
      )}
      <LoginContainer
        pageType={'account'}
        classes={{ container: styles.pageContainer }}
      />
      {isUk && <PaBanner />}
    </div>
  );
}
